import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { StoreProvider } from "@/lib/store";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Lookbook from "@/pages/Lookbook";
import Wishlist from "@/pages/Wishlist";
import Account from "@/pages/Account";
import ContentPage from "@/pages/ContentPage";

function App() {
  return (
    <div className="App bg-[color:var(--marcini-bg)] text-[color:var(--marcini-fg)]">
      <BrowserRouter>
        <StoreProvider>
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/collections/:handle" element={<Shop />} />
              <Route path="/products/:handle" element={<ProductDetail />} />
              <Route path="/lookbook" element={<Lookbook />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/account" element={<Account />} />
              <Route path="/policies/:handle" element={<ContentPage kind="policy" />} />
              <Route path="/pages/:handle" element={<ContentPage kind="page" />} />
            </Routes>
          </main>
          <Footer />
          <CartDrawer />
          <Toaster
            position="top-center"
            duration={2200}
            toastOptions={{ style: { borderRadius: 0, fontFamily: 'Manrope' } }}
          />
        </StoreProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
